export const PURPOSE_OPTIONS = [
  { value: 'new_sale_point', label: 'New Sale Point Addition' },
  { value: 'growth_existing', label: 'Growth from Existing' },
  { value: 'both', label: 'Both' },
];

export const STATUS_COLORS = {
  pending_approval: 'bg-amber-100 text-amber-700',
  approved: 'bg-blue-100 text-blue-700',
  rejected: 'bg-red-100 text-red-700',
  in_progress: 'bg-emerald-100 text-emerald-700',
  completed: 'bg-slate-100 text-slate-700',
};

export const getDays = (start, end) => {
  if (!start || !end) return 0;
  return Math.max(1, Math.ceil((new Date(end) - new Date(start)) / 86400000) + 1);
};

export const calcDuration = (cin, cout) => {
  const [ch, cm] = cin.split(':').map(Number);
  const [oh, om] = cout.split(':').map(Number);
  return (oh * 60 + om) - (ch * 60 + cm);
};

export const calcTotalExpense = (expenses) =>
  (expenses || []).reduce((s, e) => s + (e.breakfast || 0) + (e.lunch || 0) + (e.dinner || 0) + (e.night_stay > 0 ? e.night_stay : 0), 0);
